import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import { PencilIcon } from '../icons/EditorialProfileIcons';
import './index.scss';

export default function HeroCoverEditButton({
  label,
  onClick,
  className = '',
}) {
  if (typeof onClick !== 'function') {
    return null;
  }

  return (
    <button
      type="button"
      className={classNames('hero-cover-edit-button', className)}
      onClick={onClick}
      aria-label={label}
    >
      <PencilIcon width="16" height="16" />
      <span>{label}</span>
    </button>
  );
}

HeroCoverEditButton.propTypes = {
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
